import Request from "./request";

export default class StationMessageConfigsService {
  static async getStationMessageConfigs(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/StationMessageConfigs/advanceUser/getStationMessageConfigs",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ ...result.data, isSuccess: true });
        } else {
          return resolve({ isSuccess: false });
        }
      });
    });
  }
  static async updateStationMessageConfigs(data) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/StationMessageConfigs/advanceUser/updateStationMessageConfigs",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true });
        } else {
          return resolve({ isSuccess: false, error: result.error || 'An error occurred' });
        }
      });
    });
  }
  static async advanceUserGetStationListConfigs(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/StationMessageConfigs/advanceUser/getStationListConfigs",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ ...result.data, isSuccess: true });
        } else {
          return resolve({ isSuccess: false });
        }
      });
    });
  }
  static async advanceUserCreateStationMessageConfigs(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: "POST",
        path: "/StationMessageConfigs/advanceUser/createStationMessageConfigs",
        data: {
          data:data
        },
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve({ isSuccess: true });
        } else {
          return resolve({ isSuccess: false, error: result.error || 'An error occurred' });
        }
      });
    });
  }
  static async getStationConfigByStationId(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/StationMessageConfigs/advanceUser/getStationMessageConfigByStationId',
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result
        if (statusCode === 200) {
          return resolve({ ...result.data, isSuccess: true })
        } else {
          return resolve({ ...result.data, isSuccess: false })
        }
      })
    })
  }
  static async advanceUserDeleteStationMessageConfigById(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/StationMessageConfigs/advanceUser/deleteStationMessageConfigs',
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result
        if (statusCode === 200) {
          return resolve({ ...result.data, isSuccess: true })
        } else {
          return resolve({ ...result.data, isSuccess: false })
        }
      })
    })
  }
}
